/**
 * Точка входа приложения АСУБП.
 * Инициализирует React с StrictMode.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/theme/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker: register in production, unregister in development
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(console.error);
    });
  } else {
    // Unregister any existing SW in development to prevent caching issues
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    });
  }
}
